import { render, staticRenderFns } from "./OfferConfigureStepBranding.vue?vue&type=template&id=f474d1d6&scoped=true&"
import script from "./OfferConfigureStepBranding.vue?vue&type=script&lang=js&"
export * from "./OfferConfigureStepBranding.vue?vue&type=script&lang=js&"
import style0 from "./OfferConfigureStepBranding.vue?vue&type=style&index=0&id=f474d1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474d1d6",
  null
  
)

export default component.exports